export const getNextDate = (currDate: string, days: number) => {
  const [yy, mm, dd] = currDate.split("-").map(Number);
  const nextDate = new Date(Date.UTC(yy, mm - 1, dd));
  nextDate.setUTCDate(nextDate.getUTCDate() + days);
  return nextDate.toISOString().slice(0, 10);
};
